import api from './api';
import authHeader from './auth-header';

class EventsService {
    getEventsActivity(limit, after) {
        const params = new URLSearchParams();
        if (limit) {
            params.append('limit', limit.toString());
        }
        if (after) {
            params.append('after', after.toString());
        }
        const queryString = params.toString();
        const url = `/chat/events-activity${queryString ? `?${queryString}` : ''}`;
        return api.get(url, { headers: authHeader() });
    }

    getEventDetails(eventId) {
        const url = `/chat/events/${eventId}/details`;
        return api.get(url, { headers: authHeader() });
    }
}

const eventsService = new EventsService();
export default eventsService;

